module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h3', {
    staticClass: "titulo-atividades flex-header"
  }, [_c('span', [_vm._v("Experiência Profissional")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "color": "success"
    },
    on: {
      "click": _vm.novaExperiencia
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v(" "), _c('span', [_vm._v("Adicionar Experiência")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "lista-atividades"
  }, _vm._l((_vm.listaExperiencieProfissional), function(item) {
    return _c('div', {
      staticClass: "item-atividade"
    }, [_vm._m(0, true), _vm._v(" "), _c('div', {
      staticClass: "item-data"
    }, [_c('div', {
      staticClass: "item-titulo"
    }, [_vm._v(_vm._s(item.empresa) + " (" + _vm._s(item.cargo) + ")")]), _vm._v(" "), _c('div', {
      staticClass: "item-instituicao"
    }, [_vm._v(_vm._s(item.area_atuacao.nome))]), _vm._v(" "), (item.descricao) ? _c('div', {
      staticClass: "item-instituicao"
    }, [_vm._v(_vm._s(item.descricao))]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "item-periodo"
    }, [(item.dt_final) ? _c('span', [_vm._v("\n                        " + _vm._s(item.inicio) + " - " + _vm._s(item.fim) + "\n                    ")]) : _c('span', [_vm._v("\n                        Início em " + _vm._s(item.inicio) + " - Emprego atual\n                    ")])])]), _vm._v(" "), _c('div', {
      staticClass: "item-acoes"
    }, [_c('v-btn', {
      attrs: {
        "color": "info",
        "fab": "",
        "small": "",
        "outline": "",
        "title": "Editar item"
      },
      on: {
        "click": function($event) {
          return _vm.editarExperiencia(item)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-edit"
    })]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "error",
        "fab": "",
        "small": "",
        "outline": "",
        "title": "Excluir item"
      },
      on: {
        "click": function($event) {
          return _vm.removerExperiencia(item)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-times"
    })])], 1)])
  }), 0), _vm._v(" "), _c('h3', {
    staticClass: "titulo-atividades flex-header"
  }, [_c('span', [_vm._v("Formação Acadêmica")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": "",
      "color": "success"
    },
    on: {
      "click": _vm.novaFormacao
    }
  }, [_c('i', {
    staticClass: "fas fa-plus"
  }), _vm._v(" "), _c('span', [_vm._v("Adicionar Formação")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "lista-atividades"
  }, _vm._l((_vm.listaFormacaoAcademica), function(item) {
    return _c('div', {
      staticClass: "item-atividade"
    }, [_vm._m(1, true), _vm._v(" "), _c('div', {
      staticClass: "item-data"
    }, [_c('div', {
      staticClass: "item-titulo"
    }, [_vm._v(_vm._s(item.descricao))]), _vm._v(" "), _c('div', {
      staticClass: "item-instituicao"
    }, [_vm._v(_vm._s(item.instituicao.nome))]), _vm._v(" "), _c('div', {
      staticClass: "item-periodo"
    }, [(item.dt_final) ? _c('span', [_vm._v("\n                        " + _vm._s(item.inicio) + " - " + _vm._s(item.fim) + "\n                    ")]) : _c('span', [_vm._v("\n                        Início em " + _vm._s(item.inicio) + " - Em andamento\n                    ")])])]), _vm._v(" "), _c('div', {
      staticClass: "item-acoes"
    }, [_c('v-btn', {
      attrs: {
        "color": "info",
        "fab": "",
        "small": "",
        "outline": "",
        "title": "Editar item"
      },
      on: {
        "click": function($event) {
          return _vm.editarFormacao(item)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-edit"
    })]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "error",
        "fab": "",
        "small": "",
        "outline": "",
        "title": "Excluir item"
      },
      on: {
        "click": function($event) {
          return _vm.removerFormacao(item)
        }
      }
    }, [_c('i', {
      staticClass: "fas fa-times"
    })])], 1)])
  }), 0), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "70%"
    },
    model: {
      value: (_vm.mostrarModalExperiencia),
      callback: function($$v) {
        _vm.mostrarModalExperiencia = $$v
      },
      expression: "mostrarModalExperiencia"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_vm._v("\n                Experiência Profissional\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "error-messages": _vm.experienciaRefAreaAtuacaoErros,
      "items": _vm.dependencias.areas_atuacao_filtrada,
      "loading": _vm.buscandoAreasAtuacao,
      "search-input": _vm.buscarAreaAtuacao,
      "item-text": "descricao",
      "item-value": "id",
      "label": "Área de Atuação",
      "placeholder": "Digite o nome da área de atuação",
      "no-data-text": "Nenhuma registro encontrado",
      "hide-no-data": "",
      "hide-selected": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.experiencia_profissional.ref_area_atuacao.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.experiencia_profissional.ref_area_atuacao.$touch()
      },
      "update:searchInput": function($event) {
        _vm.buscarAreaAtuacao = $event
      },
      "update:search-input": function($event) {
        _vm.buscarAreaAtuacao = $event
      }
    },
    model: {
      value: (_vm.data.experiencia_profissional.ref_area_atuacao),
      callback: function($$v) {
        _vm.$set(_vm.data.experiencia_profissional, "ref_area_atuacao", $$v)
      },
      expression: "data.experiencia_profissional.ref_area_atuacao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.experienciaEmpresaErros,
      "label": "Empresa",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.experiencia_profissional.empresa.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.experiencia_profissional.empresa.$touch()
      }
    },
    model: {
      value: (_vm.data.experiencia_profissional.empresa),
      callback: function($$v) {
        _vm.$set(_vm.data.experiencia_profissional, "empresa", $$v)
      },
      expression: "data.experiencia_profissional.empresa"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.experienciaCargoErros,
      "label": "Cargo",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.experiencia_profissional.cargo.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.experiencia_profissional.cargo.$touch()
      }
    },
    model: {
      value: (_vm.data.experiencia_profissional.cargo),
      callback: function($$v) {
        _vm.$set(_vm.data.experiencia_profissional, "cargo", $$v)
      },
      expression: "data.experiencia_profissional.cargo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Descrição das atividades exercidas"
    },
    model: {
      value: (_vm.data.experiencia_profissional.descricao),
      callback: function($$v) {
        _vm.$set(_vm.data.experiencia_profissional, "descricao", $$v)
      },
      expression: "data.experiencia_profissional.descricao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.meses,
      "error-messages": _vm.experienciaMesInicialErros,
      "label": "Mês Inicial",
      "single-line": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.experiencia_profissional.mes_inicial.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.experiencia_profissional.mes_inicial.$touch()
      }
    },
    model: {
      value: (_vm.data.experiencia_profissional.mes_inicial),
      callback: function($$v) {
        _vm.$set(_vm.data.experiencia_profissional, "mes_inicial", $$v)
      },
      expression: "data.experiencia_profissional.mes_inicial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.anos,
      "error-messages": _vm.experienciaAnoInicialErros,
      "label": "Ano Inicial",
      "single-line": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.experiencia_profissional.ano_inicial.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.experiencia_profissional.ano_inicial.$touch()
      }
    },
    model: {
      value: (_vm.data.experiencia_profissional.ano_inicial),
      callback: function($$v) {
        _vm.$set(_vm.data.experiencia_profissional, "ano_inicial", $$v)
      },
      expression: "data.experiencia_profissional.ano_inicial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.meses,
      "label": "Mês Final",
      "single-line": "",
      "clearable": ""
    },
    model: {
      value: (_vm.data.experiencia_profissional.mes_final),
      callback: function($$v) {
        _vm.$set(_vm.data.experiencia_profissional, "mes_final", $$v)
      },
      expression: "data.experiencia_profissional.mes_final"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.anos,
      "label": "Ano Final",
      "single-line": "",
      "clearable": ""
    },
    model: {
      value: (_vm.data.experiencia_profissional.ano_final),
      callback: function($$v) {
        _vm.$set(_vm.data.experiencia_profissional, "ano_final", $$v)
      },
      expression: "data.experiencia_profissional.ano_final"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": _vm.botaoClicado || _vm.$v.data.experiencia_profissional.$invalid
    },
    on: {
      "click": _vm.salvarExperiencia
    }
  }, [_vm._v("\n                    Salvar Experiência\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalExperiencia = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "width": "70%"
    },
    model: {
      value: (_vm.mostrarModalFormacao),
      callback: function($$v) {
        _vm.mostrarModalFormacao = $$v
      },
      expression: "mostrarModalFormacao"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "primary white--text"
  }, [_vm._v("\n                Formação Acadêmica\n            ")]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.grau_instrucoes,
      "error-messages": _vm.formacaoRefGrauInstrucaoErros,
      "label": "Selecione o nível da formação",
      "item-text": "descricao",
      "item-value": "id",
      "single-line": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.formacao_academica.ref_grau_instrucao.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.formacao_academica.ref_grau_instrucao.$touch()
      }
    },
    model: {
      value: (_vm.data.formacao_academica.ref_grau_instrucao),
      callback: function($$v) {
        _vm.$set(_vm.data.formacao_academica, "ref_grau_instrucao", $$v)
      },
      expression: "data.formacao_academica.ref_grau_instrucao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "error-messages": _vm.formacaoRefInstituicaoErros,
      "items": _vm.dependencias.instituicoes,
      "loading": _vm.buscandoInstituicoes,
      "search-input": _vm.buscarInstituicao,
      "item-text": "nome",
      "item-value": "id",
      "label": "Instituição",
      "placeholder": "Digite o nome da instituição",
      "no-data-text": "Nenhuma registro encontrado",
      "hide-no-data": "",
      "hide-selected": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.formacao_academica.ref_instituicao.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.formacao_academica.ref_instituicao.$touch()
      },
      "update:searchInput": function($event) {
        _vm.buscarInstituicao = $event
      },
      "update:search-input": function($event) {
        _vm.buscarInstituicao = $event
      }
    },
    model: {
      value: (_vm.data.formacao_academica.ref_instituicao),
      callback: function($$v) {
        _vm.$set(_vm.data.formacao_academica, "ref_instituicao", $$v)
      },
      expression: "data.formacao_academica.ref_instituicao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "error-messages": _vm.formacaoDescricaoErros,
      "label": "Curso/Descrição",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.formacao_academica.descricao.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.formacao_academica.descricao.$touch()
      }
    },
    model: {
      value: (_vm.data.formacao_academica.descricao),
      callback: function($$v) {
        _vm.$set(_vm.data.formacao_academica, "descricao", $$v)
      },
      expression: "data.formacao_academica.descricao"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.meses,
      "error-messages": _vm.formacaoMesInicialErros,
      "label": "Mês Inicial",
      "single-line": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.formacao_academica.mes_inicial.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.formacao_academica.mes_inicial.$touch()
      }
    },
    model: {
      value: (_vm.data.formacao_academica.mes_inicial),
      callback: function($$v) {
        _vm.$set(_vm.data.formacao_academica, "mes_inicial", $$v)
      },
      expression: "data.formacao_academica.mes_inicial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.anos,
      "error-messages": _vm.formacaoAnoInicialErros,
      "label": "Ano Inicial",
      "single-line": "",
      "clearable": ""
    },
    on: {
      "input": function($event) {
        return _vm.$v.data.formacao_academica.ano_inicial.$touch()
      },
      "blur": function($event) {
        return _vm.$v.data.formacao_academica.ano_inicial.$touch()
      }
    },
    model: {
      value: (_vm.data.formacao_academica.ano_inicial),
      callback: function($$v) {
        _vm.$set(_vm.data.formacao_academica, "ano_inicial", $$v)
      },
      expression: "data.formacao_academica.ano_inicial"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm2": "",
      "xs4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.meses,
      "label": "Mês Final",
      "single-line": "",
      "clearable": ""
    },
    model: {
      value: (_vm.data.formacao_academica.mes_final),
      callback: function($$v) {
        _vm.$set(_vm.data.formacao_academica, "mes_final", $$v)
      },
      expression: "data.formacao_academica.mes_final"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs8": ""
    }
  }, [_c('v-select', {
    attrs: {
      "items": _vm.dependencias.anos,
      "label": "Ano Final",
      "single-line": "",
      "clearable": ""
    },
    model: {
      value: (_vm.data.formacao_academica.ano_final),
      callback: function($$v) {
        _vm.$set(_vm.data.formacao_academica, "ano_final", $$v)
      },
      expression: "data.formacao_academica.ano_final"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "success",
      "disabled": _vm.botaoClicado || _vm.$v.data.formacao_academica.$invalid
    },
    on: {
      "click": _vm.salvarFormacao
    }
  }, [_vm._v("\n                    Salvar Formação\n                ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.mostrarModalFormacao = false
      }
    }
  }, [_vm._v("Fechar")])], 1)], 1)], 1)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-icon"
  }, [_c('i', {
    staticClass: "fas fa-briefcase"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item-icon"
  }, [_c('i', {
    staticClass: "fas fa-user-graduate"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-eb234246!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/domains/pessoal/components/minha-conta/editar-meus-dados/FormacaoEmprego.vue
// module id = 584
// module chunks = 2